module.exports = __webpack_public_path__ + "static/img/ent-18.b642245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-18.jpg
// module id = y9Xc
// module chunks = 52